import { createIconComponent } from './createIconComponent';
import { ReactComponent as Icon } from './resources/purchases_20.svg';

export const IconPurchases20 = createIconComponent(Icon);
